class TabBar {
    constructor (options) {
        this.$tabBar = options.$tabBar;
        this.$tabBarContent = document.querySelector('[data-tab-bar-content=' + this.$tabBar.getAttribute('data-tab-bar-root') + ']');

        this.$tabList = this.$tabBar.querySelector('[data-tab-bar="tab-list"]');
        this.$tabs = this.$tabBar.querySelectorAll('[data-tab-button]');
        this.$tabContents = this.$tabBarContent.querySelectorAll('[data-tab-content]');

        this.resizeHandler = options.resizeHandler;
        this.initContent = options.initContent;
    }

    init () {
        if (this.$tabBarContent) {
            this.bindEvents();
            this.checkTabScroll();

            this.resizeHandler.customFunctions.push(() => {
                this.checkTabScroll();
            });
        }
    }

    bindEvents () {
        const addTabEvents = ($tab) => {
            $tab.addEventListener('click', () => {
                this.handleTabsState($tab);
                this.changeTabContent($tab);
            });
        };

        for (let i = 0; i < this.$tabs.length; i++) {
            const $tab = this.$tabs[i];
            addTabEvents($tab);
        }
    }

    handleTabsState ($clickedTab) {
        for (let i = 0; i < this.$tabs.length; i++) {
            const $tab = this.$tabs[i];

            if ($tab === $clickedTab) {
                $tab.classList.add('tab-bar__item--active');
            } else {
                $tab.classList.remove('tab-bar__item--active');
            }
        }
    }

    changeTabContent ($clickedTab) {
        const clickedName = $clickedTab.getAttribute('data-tab-button');
        const $tabContent = this.$tabBarContent.querySelector(`[data-tab-content="${clickedName}"]`);

        if ($tabContent) {
            const contentMarkup = $tabContent.getAttribute('data-markup');

            for (let i = 0; i < this.$tabContents.length; i++) {
                const $currentContent = this.$tabContents[i];
                const currentName = $currentContent.getAttribute('data-tab-content');

                if (currentName === clickedName) {
                    $currentContent.classList.add('tab-bar__content-item--active');
                    const contentLength = $currentContent.innerHTML.trim().length;

                    if (contentLength === 0) {
                        $tabContent.innerHTML = contentMarkup;
                    }
                    if (typeof this.initContent === 'function') {
                        this.initContent($currentContent);
                    }
                } else {
                    $currentContent.classList.remove('tab-bar__content-item--active');
                }
            }
        } else {
            console.warn('no corresponding tab content found');
        }
    }

    // set a css class for small devices to prevent the first item to be cut off
    // because of flex attribute 'justify-content: center'
    checkTabScroll () {
        if (this.$tabList) {
            const scrollWidth = this.$tabList.scrollWidth;
            const clientWidth = this.$tabList.clientWidth;

            if (scrollWidth > clientWidth) {
                this.$tabList.classList.add('tab-bar__list--scroll');
            } else {
                this.$tabList.classList.remove('tab-bar__list--scroll');
            }
        }
    }
}

export { TabBar };
